import { Link } from "react-router-dom";
import HonestyMeter from "./HonestyMeter";
import EngagementBar from "./EngagementBar";
import { VerificationBadge } from "./VerificationBadge";
import { proxied } from "@/lib/images";

export default function QuoteCard({ q, size = "md" }) {
  const isLg = size === "lg";
  return (
    <div className="bg-white border-ink shadow-brut-sm hover:shadow-brut transition-shadow" data-testid={`quote-card-${q.id}`}>
      <Link to={`/quote/${q.id}`} className="block p-6 md:p-7 group">
        <div className="flex items-center justify-between mb-4 gap-2">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="tag-red" data-testid={`quote-category-${q.id}`}>{q.category}</span>
            <VerificationBadge q={q} />
          </div>
          <span className="font-mono text-[11px] opacity-70">{q.year || "—"}</span>
        </div>
        <blockquote
          className={`font-quote leading-[1.15] ${isLg ? "text-3xl md:text-5xl" : "text-xl md:text-2xl"}`}
          data-testid={`quote-text-${q.id}`}
        >
          “{q.text}”
        </blockquote>
        <div className="mt-6 flex items-end justify-between gap-4">
          <div className="flex items-center gap-3">
            {q.speaker_image_url && (
              <img
                src={proxied(q.speaker_image_url)}
                alt={q.speaker}
                referrerPolicy="no-referrer"
                className="w-12 h-12 object-cover border border-[#0A0A0A] grayscale"
                loading="lazy"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
                data-testid={`speaker-avatar-${q.id}`}
              />
            )}
            <div className="font-body">
              <div className="font-ui text-[10px] opacity-70">Attributed to</div>
              <div className="font-display text-lg leading-tight" data-testid={`quote-speaker-${q.id}`}>{q.speaker}</div>
              {q.speaker_role && <div className="font-mono text-[10px] opacity-70">{q.speaker_role}</div>}
            </div>
          </div>
          <HonestyMeter score={q.honesty_score} />
        </div>
      </Link>
      <div className="border-t-ink px-6 py-3 flex items-center justify-between bg-[#F4F4F0]">
        <EngagementBar quote={q} dense />
        {q.source_url && (
          <a href={q.source_url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="font-ui text-[10px] link-blue" data-testid={`source-${q.id}`}>
            Source →
          </a>
        )}
      </div>
    </div>
  );
}
